import { useViewportSizes } from '.';
import { getValueFromStyledLikeArray } from '../utils/styled-helpers';
export function useStyledLikeArray(styledLikeArray) {
    const { isSmall, isMedium, isLarge, isExtraLarge } = useViewportSizes();
    if (!Array.isArray(styledLikeArray)) {
        return styledLikeArray;
    }
    let arrayKey = 0;
    if (isSmall) {
        arrayKey = 1;
    }
    else if (isMedium) {
        arrayKey = 2;
    }
    else if (isLarge) {
        arrayKey = 3;
    }
    else if (isExtraLarge) {
        arrayKey = 4;
    }
    return getValueFromStyledLikeArray(styledLikeArray, arrayKey);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLXN0eWxlZC1saWtlLWFycmF5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3VzZS1zdHlsZWQtbGlrZS1hcnJheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxHQUFHLENBQUM7QUFDckMsT0FBTyxFQUFFLDJCQUEyQixFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFFdEUsTUFBTSxVQUFVLGtCQUFrQixDQUFJLGVBQWlDO0lBQ3JFLE1BQU0sRUFBRSxPQUFPLEVBQUUsUUFBUSxFQUFFLE9BQU8sRUFBRSxZQUFZLEVBQUUsR0FBRyxnQkFBZ0IsRUFBRSxDQUFDO0lBRXhFLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxFQUFFLENBQUM7UUFDcEMsT0FBTyxlQUFlLENBQUM7SUFDekIsQ0FBQztJQUVELElBQUksUUFBUSxHQUFHLENBQUMsQ0FBQztJQUNqQixJQUFJLE9BQU8sRUFBRSxDQUFDO1FBQ1osUUFBUSxHQUFHLENBQUMsQ0FBQztJQUNmLENBQUM7U0FBTSxJQUFJLFFBQVEsRUFBRSxDQUFDO1FBQ3BCLFFBQVEsR0FBRyxDQUFDLENBQUM7SUFDZixDQUFDO1NBQU0sSUFBSSxPQUFPLEVBQUUsQ0FBQztRQUNuQixRQUFRLEdBQUcsQ0FBQyxDQUFDO0lBQ2YsQ0FBQztTQUFNLElBQUksWUFBWSxFQUFFLENBQUM7UUFDeEIsUUFBUSxHQUFHLENBQUMsQ0FBQztJQUNmLENBQUM7SUFFRCxPQUFPLDJCQUEyQixDQUFDLGVBQWUsRUFBRSxRQUFRLENBQUMsQ0FBQztBQUNoRSxDQUFDIn0=